const constants = {};

// This setting is not to be changed without authorization, and must only be changed in conjunction with the website server version.
constants.wellDriveVersion = '3.02.03.03';


constants.invalidFilenameCharacters = [
    '"', '|', '\\', '/', '<', '>', '?', ':', '*'
];

constants.invalidFilenames = [
    'aux', 'com1', 'com2', 'com3', 'com4', 'com5', 'com6', 'com7', 'com8', 'com9', 'lpt1', 'lpt2', 'lpt3', 'lpt4', 'lpt5', 'lpt6', 'lpt7', 'lpt8', 'lpt9', 'con', 'nul', 'prn', 'com'
];

constants.languages = [
    {
        name: 'English',
        isoCode: 'en'
    },
    {
        name: 'Español',
        isoCode: 'es'
    }
];

constants.wellboreProperties = [
    'Rig',
    'Spud Date',
    'State',
    'Field',
    'Country',
    'Hole Direction',
    'Well Stage',
    'Pad',
    'API',
    'County',
];

constants.supportedBrowsers = {
    chrome: '0',
    firefox: '0',
    safari: '0'
};

constants.tooltipOptions = {
    html: true
};

constants.popoverOptions = {
    template: `
        <div class="popover wd-popover" role="tooltip">
        <div class="arrow"></div>
        <h3 class="popover-title"></h3>
            <div class="popover-content"></div>
        </div>`,
    html: true,
    sanitize: false
};

constants.pageSizes = [5, 10, 20, 50, 75, 100, 200, 1000];

// These columns will always display and cannot be selected on the column filter.
constants.lockedWellboreGridColumns = [
    'checkbox',
    'spudDate',
    'name',
    'rig.name',
];

// Additional, sensible defaults.  These will be auto loaded the first time, but can be changed by the user via the column filter.
constants.defaultWellboreGridColumns = [
    'asset.name',
    'company.name',
    'field.name',
];

// These columns will always display and cannot be selected on the column filter.
constants.lockedEntryGridColumns = [
    'editDate',
    'entryTypeName',
    'fullName',
];

// Additional, sensible defaults.  These will be auto loaded the first time, but can be changed by the user via the column filter.
constants.defaultEntryGridColumns = [
    'editDate',
    'entryTypeName',
    'fullName',
    'remarks',
    'entryFiles',
];

// These columns will always display and cannot be selected on the column filter.
constants.lockedEntryAuditGridColumns = [
    'name',
];

// Additional, sensible defaults.  These will be auto loaded the first time, but can be changed by the user via the column filter.
constants.defaultEntryAuditGridColumns = [
    'spudDate',
    'name',
    'rig.name',
    'asset.name',
];

constants.lockedSearchGridColumns = [
    'editDateColumn',
    'wellboreName',
    'entryTypeName'
];

constants.defaultSearchGridColumns = [
    'rigName',
    'assetName',
    'userName',
    'entryFiles',
    'remarksColumn',
];

constants.defaultAccessGridColumns = [
    'Wellbore',
    'Company',
    'Role',
    'ReadAll',
    'Upload'
];

constants.defaultUserGridColumns = [
    'userName',
    'email',
    'firstName',
    'lastName',
    'cellNumber',
    'companyId',
    'addDate',
];

constants.userGridRoleColumns = [
    'roleName',
    'roleTypeName',
    'roleCompanyName',
];
constants.lockedUserGridColumns = [
    'userName',
];

constants.lockedInvoiceGridColumns = [
    'id',
    'wellbore.name',
    'wellbore.company.name'
];

constants.defaultInvoiceGridColumns = [
    'wellbore.company.name',
    'wellbore.asset.name',
    'id',
    'invoiceType.name',
    'invoiceStatus.name',
    'startDate',
    'endDate',
    'payDays',
    'quickBooksInvoiceNumber',
    'addDate',
    'payDate',
    'amount',
    'sentToClient',
    'user.userName',
    'remarks',
];

constants.remarksDisplayFormat = {
    simple: 'remarks',
    template: 'template',
};

constants.productionOutputFormatColumns = [
    'Company Name',
    'Rig Name',
    'Asset Name',
    'Well Name',
    'Entry Type'
];

constants.stripTagsWhiteList = [
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'b',
    'base',
    'basefont',
    'bdi',
    'bdo',
    'big',
    'body',
    'br',
    'button',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'i',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'meter',
    'nav',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'section',
    'select',
    'small',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'tt',
    'u',
    'ul',
    'var',
    'wbr'
];

constants.exportToExcelLimit = 15000;

constants.largeSearchLimit = 300000;

constants.defaultLanguage = 'en';

constants.defaultFilesPerEntry = 5;

// Width in pixels.
constants.maxMobileScreenWidth = 414;

// Time in minutes.
constants.sessionTimeout = 120;

// Time in minutes.
// Triggers when there are X minutes remaining in the session.
// So, it should always be something less than constants.sessionTimeout,
// and should always be > 0.
constants.sessionRemindTime = 30;

constants.uploaderDefaults = {
    runtimes: 'html5',
    url: ``,
    multipart: true,
    filters: { prevent_duplicates: true },
    chunk_size: '128000',
    unique_names: false,
    multiple_queues: true,
    dragdrop: true,
    container: 'plUploader',
    max_retries: 3
};

// - Requires click to close. 
// - Top screen, full width. 
constants.notifyFixedErrorOptions = {
    // Setting timeout and extendedTimeout makes the toast require click to close. 
    timeOut: 0,
    extendedTimeOut: 0,
    closeButton: true,
    positionClass: 'toast-top-full-width'
}

// - Stays longer than normal. 
// - Top screen, full width. 
constants.notifyLoginMessageOptions = {
    timeOut: 0,
    extendedTimeOut: 0,
    closeButton: true,
    positionClass: 'toast-top-full-width'
}

constants.datePickerDateTime = {
    format: 'MM/DD/YYYY hh:mm A',
    sideBySide: true,
    useCurrent: false,
};

constants.dateTimePickerDateOnly = {
    format: 'MM/DD/YYYY',
    useCurrent: false,
    showClear: true
};

constants.dateTimePickerTimeOnly = {
    format: 'hh:mm A',
    useCurrent: false,
    showClear: true
};
constants.dateTimePickerYearMonth = {
    format: 'MM/YYYY',
    useCurrent: false,
    showClear: true
};
constants.dateTimePickerYear = {
    format: 'YYYY',
    useCurrent: false,
    showClear: true
};
constants.dateTimePickerMonth = {
    format: 'MM',
    useCurrent: false,
    showClear: true
};

constants.dateFormat = 'MM/DD/YYYY';

constants.dateTimeFormat = 'YYYY-MM-DD hh:mm:ss A';

constants.wellboreProperties = [
    'Rig',
    'Spud Date',
    'State',
    'Field',
    'Country',
    'Hole Direction',
    'Well Stage',
    'Pad',
    'API',
    'County',
];
module.exports = constants;
